function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSignin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 367 L 0 512 L 512 512 L 512 367 Z M 30 397 L 380.5 397 L 380.5 482 L 30 482 Z M 482 482 L 410.5 482 L 410.5 397 L 482 397 Z M 482 482 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 79.5 424.5 L 109.5 424.5 L 109.5 454.5 L 79.5 454.5 Z M 79.5 424.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 135 424.5 L 165 424.5 L 165 454.5 L 135 454.5 Z M 135 424.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 190.5 424.5 L 220.5 424.5 L 220.5 454.5 L 190.5 454.5 Z M 190.5 424.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 246 424.5 L 276 424.5 L 276 454.5 L 246 454.5 Z M 246 424.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 301.5 424.5 L 331.5 424.5 L 331.5 454.5 L 301.5 454.5 Z M 301.5 424.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 256 326 C 345.878906 326 419 252.878906 419 163 C 419 73.121094 345.878906 0 256 0 C 166.121094 0 93 73.121094 93 163 C 93 252.878906 166.121094 326 256 326 Z M 215.78125 133.21875 C 215.78125 111.039062 233.820312 93 256 93 C 278.179688 93 296.21875 111.039062 296.21875 133.21875 C 296.21875 155.398438 278.179688 173.441406 256 173.441406 C 233.820312 173.441406 215.78125 155.398438 215.78125 133.21875 Z M 256 296 C 227.539062 296 201.140625 287.011719 179.488281 271.730469 C 177.019531 269.988281 174.621094 268.171875 172.289062 266.28125 C 176.339844 252.238281 183.878906 239.46875 194.378906 228.96875 C 210.839844 212.511719 232.71875 203.441406 256 203.441406 C 295.109375 203.441406 329.070312 229.410156 339.710938 266.28125 C 337.378906 268.171875 334.980469 269.988281 332.511719 271.730469 C 310.859375 287.011719 284.460938 296 256 296 Z M 256 30 C 329.339844 30 389 89.660156 389 163 C 389 192.671875 379.230469 220.101562 362.75 242.25 C 350.988281 216.238281 330.121094 195.589844 304.511719 183.941406 C 317.878906 171.148438 326.21875 153.140625 326.21875 133.21875 C 326.21875 94.5 294.71875 63 256 63 C 217.28125 63 185.78125 94.5 185.78125 133.21875 C 185.78125 153.128906 194.109375 171.128906 207.460938 183.910156 C 194.851562 189.640625 183.25 197.660156 173.160156 207.75 C 163.070312 217.839844 155.019531 229.5 149.25 242.238281 C 132.761719 220.089844 123 192.671875 123 163 C 123 89.660156 182.660156 30 256 30 Z M 256 30 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignin);
export default __webpack_public_path__ + "static/media/signin.5b49ae8894332cd9b83565bb6d631091.svg";
export { ForwardRef as ReactComponent };